import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import SearchIcon from '../../../assets/svg/search/search.svg?react';
import FiltersIcon from '../../../assets/svg/search/filter.svg?react';
import SearchCloseIcon from '../../../assets/svg/search/delete-search.svg?react';
import styles from './FJSearch.module.less';
import FJSearchHistory from './FJSearchHistory';
import FJSearchAutoComplete from './FJSearchAutoComplete';
import FJSearchTypeDropdown from './FJSearchTypeDropdown';

class FJSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterActive: false,
            historyActive: false,
            categorySortActive: false,
            autoCompleteActive: false,
            filterChangeCount: 0, // 筛选内容已被修改的数量
            historyPanel: {
                width: 1,
                left: 0,
                top: 0,
            },
            selectObj: {},
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateUI);
        this.container.addEventListener('resize', this.updateUI);

        this.updateUI();

        this.input.addEventListener('dragstart', e => {
            e.preventDefault();
        });
        window.addEventListener('resize', this._resize);
        if (window.FJEvent) {
            this._eventSubscribe = window.FJEvent.subscribe('CLOSE_FILTER_SEARCH', () => {
                if (this.state.filterActive) this._closeFilter();
                if (this.state.categorySortActive) this._closeCategorySort();
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.filterActive || this.state.categorySortActive) this._bindMouseEvent();
        else this._unbindMouseEvent();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateUI);
        this.container.removeEventListener('resize', this.updateUI);

        window.removeEventListener('resize', this._resize);
        if (this._eventSubscribe) {
            this._eventSubscribe();
        }
    }

    _resize = () => {
        this.input.blur();
    };

    /**
     * @description
     * @private
     */
    _hideHistory = () => {
        this.input?.blur();
    };

    _showOrHideFilterView = () => {
        if (this.props.categorySort && this.props.categorySort.length > 0) {
            this._showOrHideCategorySort();
            return;
        }
        if (this.state.filterActive) {
            this._closeFilter();
        } else {
            this._openFilter();
        }
    };

    _showOrHideCategorySort = () => {
        if (this.state.categorySortActive) {
            this._closeCategorySort();
        } else {
            this._openCategorySort();
        }
    };

    /**
     * @description 判断是否显示历史
     * @param hasAutoComplete
     * @param isEmpty
     * @returns {*|boolean|boolean}
     * @private
     */
    _getHistoryActive = (hasAutoComplete, isEmpty) => {
        if (hasAutoComplete) {
            return isEmpty && this.state.historyActive;
        } else {
            return this.state.historyActive;
        }
    };

    /**
     * @description 键盘上下键设置input的值
     * @param value
     * @private
     */
    _moveUpOrDown = value => {
        this.props.setKeywords(value);
    };

    /**
     * @description  渲染search 的type的页面
     * @private
     */
    _getSearchTypeComp = () => {
        let { searchTypeList } = this.props;
        return (
            <Fragment>
                <i className={styles.search_multiple} style={{ right: '112px', height: '100%' }} />
                <FJSearchTypeDropdown
                    list={searchTypeList}
                    dataChange={this._onSearchTypeChange}
                    ref={ele => (this._searchTypeRef = ele)}
                />
            </Fragment>
        );
    };

    _onSearchTypeChange = index => {
        if (this.props.value.trim() === '') {
            this.props.onChange('');
            this._searchTypeRef.hideDropdown();
        }
        this.props.onSearchTypeChange && this.props.onSearchTypeChange(index);
    };

    /**
     * @description 点击多选之后触发
     * @param data
     * @private
     */
    _onSearchMultipleChange = dataObj => {
        let selectObj = JSON.parse(JSON.stringify(dataObj));
        let selectObjChooseNum = 0;
        for (let key in selectObj) {
            if (selectObj[key] && selectObj[key].length > 0) {
                selectObjChooseNum += selectObj[key].length;
            }
        }
        this.setState(
            {
                selectObj,
                filterChangeCount: selectObjChooseNum,
            },
            () => {
                this.props.onSearchMultipleChange && this.props.onSearchMultipleChange(selectObj, this.input.value);
            },
        );
    };

    _getClearRight = () => {
        let selectObj = this.state.selectObj;
        let hasChooseNum = 0;
        for (let key in selectObj) {
            if (selectObj[key] && selectObj[key].length > 0) {
                hasChooseNum++;
            }
        }

        let right = 0;
        if (hasChooseNum === 0) {
            right = 170;
        } else if (hasChooseNum === 1) {
            right = 200;
        } else {
            right = 234;
        }
        return right;
    };

    render() {
        let {
            isElement,
            placeHolder,
            className,
            theme,
            value,
            sortType,
            history,
            couldSort,
            style = {},
            populars = [],
            hasAutoComplete = false,
            completeList = [],
            maxHeight,
            hasSearchType,
            categorySort = [],
            enableFilter,
            filterData,
            enableFilterColors,
            filterRatioData,
            onRadioChange,
            hasIcon = true,
            iconSrc,
            isDisabled = false,
            inputStyle = {},
            hasMaxLength = true,
            maxLength = 100,
        } = this.props;
        let disabled = value === '';
        let isEmpty = value && value.length > 0 ? false : true;

        let clearRight = 12;
        if (couldSort) clearRight = 210;
        if (hasSearchType) clearRight = 124;

        return (
            <div ref={ele => (this.container = ele)} style={style} className={classNames(styles.box, className, theme)}>
                {hasIcon ? (
                    !!iconSrc ? (
                        <img src={iconSrc} className={styles.search_icon} />
                    ) : (
                        <SearchIcon className={styles.search_icon} />
                    )
                ) : null}
                <input
                    value={value}
                    className={classNames(
                        couldSort || categorySort.length > 0 ? styles.sort_input : '',
                        hasSearchType ? styles.type_input : '',
                        isElement ? styles.element_input : '',
                        !this._getHistoryActive(hasAutoComplete, isEmpty) &&
                            !(!isEmpty && hasAutoComplete && completeList.length > 0 && this.state.autoCompleteActive)
                            ? styles.no_history_input
                            : '',
                        (filterRatioData || categorySort) && enableFilter ? styles.filter_input : '',
                    )}
                    style={inputStyle}
                    ref={ele => (this.input = ele)}
                    onBlur={this._onBlur}
                    onFocus={this._onFocus}
                    onChange={this.onInputChange}
                    onKeyDown={this.onInputKeyDown}
                    placeholder={placeHolder}
                    disabled={isDisabled}
                    maxLength={hasMaxLength ? maxLength : ''}
                />
                <div className={styles.right_icon_btn}>
                    <div
                        className={styles.clear_icon}
                        style={{ display: isEmpty ? 'none' : 'flex' }}
                        onClick={this.clear}
                    >
                        <SearchCloseIcon />
                    </div>

                    <div className={styles.split_line} style={{ display: enableFilter ? 'block' : 'none' }} />
                    <div
                        ref={ele => (this._filterButton = ele)}
                        style={{ display: enableFilter ? 'flex' : 'none' }}
                        className={styles.filter_icon}
                        onClick={this._showOrHideFilterView}
                    >
                        <FiltersIcon />
                        <div
                            className={styles.filter_count}
                            style={{ display: this.state.filterChangeCount !== 0 ? 'flex' : 'none' }}
                        >
                            {this.state.filterChangeCount}
                        </div>
                    </div>
                </div>

                <FJSearchHistory
                    onSearch={this.onKeywordSubmit}
                    style={this.state.historyPanel}
                    onClear={this.onClearHistory}
                    keywords={history}
                    active={this._getHistoryActive(hasAutoComplete, isEmpty)}
                    populars={populars}
                    hide={this._hideHistory}
                    isElement={isElement}
                    maxHeight={maxHeight}
                    ref={ele => (this._searchHistory = ele)}
                />

                <FJSearchAutoComplete
                    onSearch={this.onKeywordSubmit}
                    active={!isEmpty && hasAutoComplete && completeList.length > 0 && this.state.autoCompleteActive}
                    completeList={completeList}
                    style={this.state.historyPanel}
                    ref={ele => (this._searchAutoComplete = ele)}
                    moveUpOrDown={this._moveUpOrDown}
                    maxHeight={maxHeight - 20}
                />
            </div>
        );
    }

    _applyFilter = () => {
        if (this._searchFilterRef) {
            let count = this._searchFilterRef.getFilterChangeCount();
            this.setState({ filterChangeCount: count }, () => {
                this.props.onSubmit();
            });
        }
    };
    _closeFilter = () => {
        this.setState({ filterActive: false });
    };
    _openFilter = () => {
        this.setState({ filterActive: true });
    };

    _closeCategorySort = () => {
        this.setState({ categorySortActive: false });
    };
    _openCategorySort = () => {
        this.setState({ categorySortActive: true });
    };

    _bindMouseEvent = () => {
        if (this._isBindEvent) return;
        this._isBindEvent = true;
        document.body.addEventListener('mousedown', this._mouseDown);
        window.addEventListener('keydown', this._keyDown);
    };

    _unbindMouseEvent = () => {
        if (!this._isBindEvent) return;
        this._isBindEvent = false;
        document.body.removeEventListener('mousedown', this._mouseDown);
        window.removeEventListener('keydown', this._keyDown);
    };

    _mouseDown = e => {
        if (
            !(this._searchFilterRef || this._searchRatioFilterRef || this._searchCategorySortRef) ||
            !this._filterButton
        ) {
            return;
        }
        // 判断是否点击了menu的区域
        let p = {
            x: e.clientX,
            y: e.clientY,
        };

        let rect = this._filterButton.getBoundingClientRect();
        let isHitFilterButton =
            p.x >= rect.x && p.x <= rect.x + rect.width && p.y >= rect.y && p.y <= rect.y + rect.height;
        if (
            !isHitFilterButton &&
            ((this._searchFilterRef && !this._searchFilterRef.isHit(p)) ||
                (this._searchRatioFilterRef && !this._searchRatioFilterRef.isHit(p)) ||
                (this._searchCategorySortRef && !this._searchCategorySortRef.isHit(p)))
        ) {
            this._closeFilter();
            this._closeCategorySort();
        }
    };

    _keyDown = e => {
        if (e.key === 'Escape') {
            this._closeFilter();
        }
    };

    onClearHistory = () => {
        this.props.onClearHistory();
        this.input.blur();
    };
    onInputChange = e => {
        this.props.onChange(e.target.value);
    };
    onInputKeyDown = e => {
        if (e.keyCode === 13) {
            if (e.target.value.trim() === '') {
                this.props.onChange('');
            } else {
                this.input.blur();
                this.props.onSubmit(e.target.value);
            }
        } else if (e.keyCode === 38) {
            // 按下 上
            this._searchAutoComplete && this._searchAutoComplete.reduceIndex();
        } else if (e.keyCode === 40) {
            // 按下 下
            this._searchAutoComplete && this._searchAutoComplete.addIndex();
        } else if ((e.ctrlKey || e.metaKey) && e.keyCode === 65) {
            const value = this.input.value;
            this.input.value = '';
            this.input.value = value;
            this.input.select();
        }
    };

    onKeywordSubmit = (value, isHartWords = false) => {
        value = value.trim();
        this.input.blur();
        this.props.onChange(value);
        this.props.onSubmit(value, isHartWords);
        window.is_popular = false;
    };

    onSortChange = type => {
        if (this.props.value.trim() === '') {
            this.props.onChange('');
            this.sort.hideDropdown();
        } else {
            this.props.onSortChange(type);
        }
    };

    clear = () => {
        this.props.onChange('');
        this.props.onClear && this.props.onClear();
    };
    _onBlur = () => {
        this.setState({
            historyActive: false,
            autoCompleteActive: false,
        });
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };
    _onFocus = () => {
        let { history = [], populars = [] } = this.props;
        this._closeFilter();
        this._closeCategorySort();
        if (history.length !== 0 || populars.length !== 0) {
            this.setState({
                historyActive: true,
                autoCompleteActive: true,
                historyPanel: this.getStyle(),
            });
        }

        if (this.props.value.trim()) {
            this.props.onChange(this.props.value);
            this._searchAutoComplete.init();
        }
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };
    getStyle = () => {
        if (!this.container) {
            return {
                width: 0,
                top: 0,
                left: 0,
            };
        }
        let { width, height, top, left } = this.container.getBoundingClientRect();
        return {
            width: width,
            top: height + top - 1,
            left: left,
        };
    };
    updateUI = () => {
        if (this.container) {
            this.setState({
                historyPanel: this.getStyle(),
            });
        }
    };
    getSearchFilterData = () => {
        if (!this.props.enableFilter) return {};
        return this._searchFilterRef.getSelectedData();
    };
    focus = () => {
        this.input.focus();
    };
}

export default FJSearch;
